import React from 'react'
import PropTypes from 'prop-types'

import { useStyles } from './plan-details.styles'

/**
 * Renders a list of plan details in a styled card component
 *
 * @param {Object} props - Component props
 * @param {Array<{name: string, value: string}>} props.detail - Array of plan detail objects with name and value
 * @param {boolean} [props.isUpgradingPlan=false] - Flag indicating if user is upgrading their plan
 */
const PlanDetails = ({ detail, isUpgradingPlan = false, showVoucherMessage = false }) => {
  const styles = useStyles()

  // Checks if a value is a valid date string
  const isDateValue = (value) => !isNaN(new Date(value).getTime()) && !value.includes('$')

  // Separate the first item (plan title) from the rest
  const [planTitle, ...details] = detail

  return (
    <div className={styles.detailCard}>
      {showVoucherMessage && (
        <div className={styles.badge}>Voucher Applied</div>
      )}
      <div className={styles.planHeader}>
        <span className={styles.planName}>{planTitle.name}</span>
        <span className={styles.planPrice}>{planTitle.value}</span>
      </div>

      <ul className={styles.detailList} data-e2e="plan-detail-label-value">
        {details.map((planDetail) => (
          <li key={planDetail.name} className={styles.detailItem}>
            <span className={styles.detailLabel}>
              {planDetail.name}
              &nbsp;
            </span>
            <span className={styles.detailValue}>
              {isDateValue(planDetail.value) && isUpgradingPlan ? 'Today' : planDetail.value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export const PlanDetailPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })
).isRequired

PlanDetails.propTypes = {
  detail: PlanDetailPropTypes,
  isUpgradingPlan: PropTypes.bool,
  showVoucherMessage: PropTypes.bool
}

export default PlanDetails
